import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import Swal, { SweetAlertIcon, SweetAlertResult } from 'sweetalert2';
import { JwtToken } from '../models/auth.models';
import { jwtDecode } from 'jwt-decode';
import { Router } from '@angular/router';
import { EnumStatus, EnumHttp, EnumPermission } from '../models/enum';
import { CurrencyPipe } from '@angular/common';

@Injectable({
	providedIn: 'root'
})
export class ConfigService {

	Version = "3.0.0";
	
    token!: JwtToken;

	url = {
		DefaultAvatar: "/assets/images/users/defaultAvatar.jpg",
		ImageGalleryList: "v1/api/image_galleryList",
		ImageGalleryUploadHandler: "v1/api/app_upload_handler",
		// Domain: location.hostname == "localhost" ? "http://localhost/CNT/BIZ/CNT-IWK-BIZ-API/public/" : "https://api.bizportal.iwk.com.my/",
		Domain: "https://api.bizportal.iwk.com.my/",
		Login: "admin/login",
		AdminRes: "admin",
		AdminUpdatePassword: "admin/updatePassword/",
		AdminAuthorityRes: "adminAuthority",
		OperationLogGet: "operationLog",
		Report: "report/",
		DownloadLogGet: "company/downloadLog",
		TaskRes: "task",
		TaskFormRes: "taskForm",
		TaskFormMatch: "taskForm/match/",
		AnnouncementRes: "announcement",
		FAQRes: "faq",
		IndustryRes: "industry",
		IndustryGetList: "industry/getList",
		SystemRes: "system",
		SystemGetFaqCategoryList: "system/getFaqCategoryList",
		CompanyRes: "company",
		CompanyUpdatePassword: "company/updatePassword/",
		SanRes: "san",
		ContactUsRes: "contactUs",
	}

	loadingAlert: any;

	constructor(
		private router: Router,
        public http: HttpClient,
		private currencyPipe: CurrencyPipe) {
	}

	showAlert(title: string, msg: string = "", icon: SweetAlertIcon = "success", autoCloseTime = 1500, callback = (value: SweetAlertResult) => {}) {
		let timeOut: any = null;
		if(autoCloseTime != null){ timeOut = setTimeout(() => { Swal.close(); }, autoCloseTime); }
		Swal.fire(title, msg, icon).then((value) => {
			timeOut && clearTimeout(timeOut);
			callback(value);
		});
	}

	showConfirm(title: string, text: string, confirmCallback = () => {}){
		Swal.fire({title, text, icon: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Confirm', cancelButtonText: 'Cancel', reverseButtons: true }).then((result) => {
			if (result.isConfirmed) { confirmCallback(); }
			else if (result.isDismissed) { Swal.close(); }
		});
	}

	showTextConfirmation(title: string = "Delete Confirmation", text: string = "Please type 'DELETE' to confirm:", confirmCallback = () => {}, textType: string = "DELETE"){
		Swal.fire({ title, text, input: 'text', inputPlaceholder: textType, showCancelButton: true, confirmButtonText: 'Confirm', cancelButtonText: 'Cancel', reverseButtons: true,
			preConfirm: (inputValue) => {
				return new Promise<void>((resolve, reject) => {
					if (inputValue === textType) { resolve(); }
					else {
						Swal.showValidationMessage('Input is incorrect. Please type ' + textType + '.');
						let btnConfirm = Swal.getConfirmButton();
						let btnCancel = Swal.getCancelButton();
						btnConfirm && (btnConfirm.disabled = false);
						btnCancel && (btnCancel.disabled = false);
					}
				});
			},
			didOpen: () => {
			  const inputElement = Swal.getInput();
			  if (inputElement) {
				inputElement.setAttribute('autocomplete', 'off new-password');
				inputElement.setAttribute('autocorrect', 'off');
				inputElement.setAttribute('autocapitalize', 'off');
				inputElement.setAttribute('spellcheck', 'false');
			  }
			}
		}).then((result) => { result.isConfirmed && confirmCallback(); });
	}

	// showAlert(title: string, msg: string) {
	// 	Swal.fire(title, msg, 'success');
	// }

	showError(title: string, msg: string) {
		Swal.fire(title, msg, 'warning');
	}

	showLoading(display: boolean = true, timer: number = 100, mytitle: string = 'Loading '){
		if (display) {
			let html = '<div id="myloading" style="height:130px;padding-top:40px"><div><div class="spinner-chase"><div class="chase-dot"></div><div class="chase-dot"></div><div class="chase-dot"></div><div class="chase-dot"></div><div class="chase-dot"></div><div class="chase-dot"></div></div></div></div>';

			html += "<h3>" + mytitle + "</h3>";
			this.loadingAlert = Swal.fire({
				width: 400,
				padding: 30,
				html: html,
				allowOutsideClick: false,
				timerProgressBar: true,
				showConfirmButton: false,
				timer: 300000,
			});
		} else {
			if (this.loadingAlert) {
				setTimeout(() => {
					this.loadingAlert.close();
				}, timer);
			}

		}

	}

	imgErrorHandler(event: any) {
		//console.log("errorimg",event);
		if (event.type == "error") {
			let src = event['target']['src'];
			event['target']['src'] = "./assets/images/imgNotFound.png";
			//console.log(src);

		}
	}

	

    checkToken() {
        let token = localStorage.getItem("Token");
        if(token == null){
            return false;
        }else{
            try {
                let tokenDecode: JwtToken = jwtDecode(token);
                if(tokenDecode.exp > Date.now() / 1000){
                    return true;
                }else{
                    localStorage.removeItem("Token");
                    return false;
                }
            } catch (Error) {
                localStorage.removeItem("Token");
                return false;
            }
        }
    }
	checkPermission(permission: EnumPermission | string): boolean {
	  return this.token.authority_list.includes(permission);
	}

    sendReq(url: string, data: any = {}, httpMethod: EnumHttp, callback = (res: any) => {}, showLoading = false) {
		showLoading && this.showLoading();
		let headers = new HttpHeaders().set('Authorization', `Bearer ${localStorage.getItem('Token')}`);
		let method;
		switch(httpMethod){
			case EnumHttp.GetAuth   : {
				let params = new HttpParams();
				data && Object.keys(data).forEach(key => { params = params.append(key, data[key]); });
				method = this.http.get(this.url.Domain + url, { headers, params }); break;
			}
			case EnumHttp.PutAuth   : method = this.http.put(this.url.Domain + url, data, { headers }); break;
			case EnumHttp.PostAuth  : method = this.http.post(this.url.Domain + url, data, { headers }); break;
			case EnumHttp.DeleteAuth: method = this.http.delete(this.url.Domain + url, { headers }); break;
			case EnumHttp.Get   : {
				let params = new HttpParams();
				data && Object.keys(data).forEach(key => { params = params.append(key, data[key]); });
				method = this.http.get(this.url.Domain + url, { params }); break;
			}
			case EnumHttp.Put   : method = this.http.put(this.url.Domain + url, data); break;
			case EnumHttp.Post  : method = this.http.post(this.url.Domain + url, data); break;
			case EnumHttp.Delete: method = this.http.delete(this.url.Domain + url); break;
			default				: method = this.http.post(this.url.Domain + url, data); break;
		}
		method.subscribe({
		  	next: (data: any) => {
				location.hostname == "localhost" && console.log(url, data);
				if(data && data.code == EnumStatus.Success){
					data.token && localStorage.setItem("Token", data.token);
					callback(data);
				}else if(data){
					if(data.data && typeof data.data === "object"){
						this.showAlert((<any>Object).values(data.data)[0][0], "", "error", 3000);
						callback(data);
					}else if(data.code == EnumStatus.Unauthorize){
						this.showAlert(data.message, "", "error", 3000, () => {
						  this.router.navigate(['/login']);
						});
					}else{
						this.showAlert(data.message, "", "error", 3000);
						callback(data);
					}
				}
			},
		  	error: (error: any) => {
				if(error.error && error.error.message){
					if(error.error.message.includes("Token")){
						localStorage.removeItem("Token");
						this.showAlert(error.error.message, "", "error", 3000, () => {
						  this.router.navigate(['/login']);
						});
					}else{
						this.showAlert(error.error.message, "", "error", 3000);
						callback(error.error);
					}
				}else{
					this.showAlert("Server Internal Error", "", "error", 3000);
					callback(error.error);
				}
			}
		})
    }
	
	generateTableList(tableId: string = "myTable", url: string, columns: any, parent: any = this, callbackData:any = null, callbackFirstGetData: any = null, filterListId: string = "filterList", pageLength: number = 10, dataDataTableName = "dataDT"){
		let isFirstCall = true;
		let config: any = this;
		let isFirstGetData = true;
		let inputCheck: any = {};
		let result = {
			inputCheck: [],
			responsive: true,
			serverSide: true,
			stateSave: true,
			lengthChange: true,
			processing: true,
			searching: true,
			pageLength, // 设置每页显示的记录数
			order: [[0,'desc']],
			ajax: {
				url: this.url.Domain + url,
				type: "Get",
				headers: { 'Authorization': 'Bearer ' + localStorage.getItem("Token") },
				data: (res: any) => {
					let data: any = {
					  start: res.start, // 当前页码
					  limit: res.length,              // 每页的记录数
					  order_by: res.order.length == 0 ? "id desc" : res.columns[res.order[0].column].data + ' ' + res.order[0].dir, // 排序信息
					  query: res.search.value        // 搜索关键词
					};
					if(isFirstCall){ columns.forEach((element: any) => { if(element.inputDefault){ data[element.data] = element.inputDefault; } }); }
					Object.entries(inputCheck).forEach((element: any) => {
						if(element[1].value && element[0].endsWith("_end")){
							let date = new Date(element[1].value);
							date.setDate(date.getDate() + 1);
							data[element[0]] = date.toISOString().split('T')[0];
						}else{
							data[element[0]] = element[1].value;
						}
					});
					callbackData && (data = callbackData(data, res));
					return data;
				  },
				// dataSrc: "data.list",
				dataSrc: {
					data: 'data.list',
					recordsTotal: 'data.total',
					recordsFiltered: 'data.total'
				},
				complete: (jqXHR: any) => {
					location.hostname == "localhost" && console.log(jqXHR.responseJSON);
					jqXHR.responseJSON.token && localStorage.setItem("Token", jqXHR.responseJSON.token);
					jqXHR.responseJSON.data && parent[dataDataTableName] && (parent[dataDataTableName] = jqXHR.responseJSON.data);
					if(isFirstGetData){
						isFirstGetData = false;
						callbackFirstGetData && (callbackFirstGetData(jqXHR.responseJSON));
					}
				},
				error: (jqXHR: any) => {
				  if(jqXHR.responseJSON && jqXHR.responseJSON.message){
					  if(jqXHR.responseJSON.message.includes("Token")){
						  localStorage.removeItem("Token");
						  this.showAlert(jqXHR.responseJSON.message, "", "error", 3000, () => {
							this.router.navigate(['/login']);
						  });
					  }else{
						  this.showAlert(jqXHR.responseJSON.message, "", "error", 3000);
					  }
				  }else{
					  this.showAlert("Server Internal Error", "", "error", 3000);
				  }
				}
			},
			rowCallback: (row: Node, data: any | Object, index: number) => {
				// initialFunction
				data['urlTable'] = url;
				data['tableId'] = tableId;
				data['index'] = index;
				$('td', row).off('click');
				$('.btn', row).on('click', function () {
				let clickFunction = $(this)[0].attributes.getNamedItem('clickFunction');
				if(clickFunction && clickFunction.value){
					if (clickFunction.value.startsWith("[{<Config>}]")) {
						config[clickFunction.value.slice("[{<Config>}]".length)](data, index);
					}else{
						parent[clickFunction.value](data, index);
					}
				}
			  });
			  $('.bx', row).on('click', function () {
				let clickFunction = $(this)[0].attributes.getNamedItem('clickFunction');
				if(clickFunction && clickFunction.value){
					if (clickFunction.value.startsWith("[{<Config>}]")) {
						config[clickFunction.value.slice("[{<Config>}]".length)](data, index);
					}else{
						parent[clickFunction.value](data, index);
					}
				}
			  });
			},
			preDrawCallback: function (settings: any) {
				$(".dt-search").hide();
				$('#myTable thead').addClass('table-dark');
			},
			columnDefs: [{
				targets: '_all', // 作用于所有列
				className: 'align-middle' // 设置类名
			}],
			columns
		};
		setTimeout(() => {
			let timeoutKeydown:any = null;
			let filterList: any = document.getElementById(filterListId);
			let functionRedraw = () => {
				clearTimeout(timeoutKeydown);
				timeoutKeydown = setTimeout(() => { $('#' + tableId).DataTable().draw(); }, 300);
			};
			columns.sort((a: any, b: any) => {
				const aPriority = a.inputPriority !== undefined ? a.inputPriority : Infinity;
				const bPriority = b.inputPriority !== undefined ? b.inputPriority : Infinity;
				return aPriority - bPriority;
			  });
			columns.forEach((column: any) => {
				if(column.inputType){
					switch(column.inputType){
						case "text": case "number": case "email": case "tel": {
							let label = document.createElement("label");
							label.className = "col-md-3 mb-3 form-label";
							label.innerText = column.title;
							label.htmlFor = "inputFilter_" + column.data;
							let input = document.createElement("input");
							input.type = column.inputType;
							input.id = "inputFilter_" + column.data;
							input.className = "form-control ng-pristine ng-valid ng-touched";
							input.onkeydown = input.onchange = functionRedraw;
							inputCheck[column.data] = input;
							column.inputDefault && (input.value = column.inputDefault);
							label.appendChild(input);
							filterList.appendChild(label);
							break;
						}
						case "fromTo": {
							let labelFrom = document.createElement("label");
							let labelTo = document.createElement("label");
							let inputFrom = document.createElement("input");
							let inputTo = document.createElement("input");
							labelFrom.className = labelTo.className = "col-md-3 mb-3 form-label";
							labelFrom.innerText = "From " + column.title;
							labelTo.innerText = "To " + column.title;
							labelFrom.htmlFor = "inputFilterFrom_" + column.data;
							labelTo.htmlFor = "inputFilterTo_" + column.data;
							inputFrom.type = inputTo.type = column.inputData;
							inputFrom.className = inputTo.className = "form-control ng-pristine ng-valid ng-touched";
							inputFrom.id = "inputFilterFrom_" + column.data;
							inputTo.id = "inputFilterTo_" + column.data;
							inputFrom.onkeydown = inputTo.onkeydown = inputFrom.onchange = inputTo.onchange = functionRedraw;
							let suffix = column.inputData == "date" ? ["_start", "_end"] : ["_over", "_less"];
							inputCheck[column.data + suffix[0]] = inputFrom;
							inputCheck[column.data + suffix[1]] = inputTo;
							column.inputDefaultFrom && (inputFrom.value = column.inputDefaultFrom);
							column.inputDefaultTo && (inputTo.value = column.inputDefaultTo);
							labelFrom.appendChild(inputFrom);
							labelTo.appendChild(inputTo);
							filterList.appendChild(labelFrom);
							filterList.appendChild(labelTo);
							break;
						}
						case "select": {
							let label = document.createElement("label");
							label.className = "col-md-3 mb-3 form-label";
							label.innerHTML = column.title + '<br>';
							label.htmlFor = "inputFilter_" + column.data;

							let select = document.createElement("select");
							select.id = "inputFilter_" + column.data;
							select.className = "form-select border-secondary inputFilter_" + column.data;
							select.onchange = functionRedraw;
							inputCheck[column.data] = select;

							column.inputData.forEach((e: any) => {
								select.innerHTML += typeof e === "string" ? `<option value='${e}'>${e}</option>` : `<option value='${e[0]}'>${e[1]}</option>`;
							});
							column.inputDefault && (select.value = column.inputDefault);
							label.appendChild(select);
							filterList.appendChild(label);
							break;
						}
						default: break;
					}
				}
			});
			result.inputCheck = inputCheck;
		}, 100);
		return result;
	}

	getSubList(url: string, idInputFilterSubList: string, callback = (res: any, inputFilter_subList: any) => {}, data: any = { select: "id, name", limit: 99999, order_by: "name asc" }){
	  this.sendReq(url, data, EnumHttp.GetAuth, (res) => {
		if(res.code == EnumStatus.Success){
		  let intervalGetSubList = setInterval(() => {
			let inputFilter_subList: any = document.getElementById(idInputFilterSubList);
			if(inputFilter_subList){
			  clearInterval(intervalGetSubList);
			  callback(res, inputFilter_subList);
			}
		  }, 100);
		}
	  })
	}
	

	changeStatus(data: any, index: number) {
		this.showConfirm(`${data.status == 1 ? "Ina" : "A"}ctivation`, `Are you sure want to ${data.status == 1 ? 'in' : ''}activate${data.name ? ` "${data.name}"` : ''}?`, () => {
		  this.showLoading();
		  data.status = data.status == 1 ? 0 : 1;
		  this.sendReq(data.urlTable + "/" + data.id, data, EnumHttp.PutAuth, (res) => {
			if(res.code == EnumStatus.Success){
			  this.showAlert("Success", `Change Status${data.name ? ` "${data.name}"` : ''} Successful`);
			  $('#' + data.tableId).DataTable().draw(false);
			}
		  })
		});
	}

	delete(data: any, index: number = 0) {
	  this.showTextConfirmation("Delete Confirmation", `Please type 'DELETE' to continue${data.name ? ` delete "${data.name}"` : ''}:`, () => {
		this.showLoading();
		this.sendReq(data.urlTable + "/" + data.id, null, EnumHttp.DeleteAuth, (res) => {
		  if(res.code == EnumStatus.Success){
			this.showAlert("Success", `Delete${data.name ? ` "${data.name}"` : ''} Successful`);
			$('#' + data.tableId).DataTable().draw(false);
		  }
		})
	  });
	}

	copyUniqId(data: any, index: number = 0){
	  navigator.clipboard.writeText(data.uniq_id);
	  this.showAlert("Success", `Copy Uniq Id "${data.uniq_id}" Successful`);
	}

	deleteInAdd(data: any, mainModule: string, url: string) {
	  this.showTextConfirmation("Delete Confirmation", `Please type 'DELETE' to continue${data.name ? ` delete "${data.name}"` : ''}:`, () => {
		this.showLoading();
		this.sendReq(url + "/" + data.id, null, EnumHttp.DeleteAuth, (res) => {
		  if(res.code == EnumStatus.Success){
			this.showAlert("Success", `Delete${data.name ? ` "${data.name}"` : ''} Successful`, "success", 1500, () => {
			  this.router.navigate(['/' + mainModule.toLowerCase() + '/list']);
			});
		  }
		})
	  });
	}
	
	resetfilter(dtOptions: any, tableId: string = "myTable") {
		Object.values(dtOptions.inputCheck).forEach((e: any) => { e.value = ""; });
		$('#' + tableId).DataTable().draw();
	}

	exportExcel(data: [] = [], filename: string = "downloadFile") {
		
		const csvRows = [];

		// 提取每一行数据
		for (const row of data) {
			const values = (<any>row).map((value: any) => {
				const escaped = ('' + value)
					.replace(/"/g, '""') // 转义双引号
					.replace(/\n/g, '\\n'); // 替换换行符
	
				return `"${escaped}"`; // 用双引号包裹每个字段
			});
			csvRows.push(values.join(','));
		}

		const csv = csvRows.join('\n');
		const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
		const url = URL.createObjectURL(blob);
		
		const a = document.createElement('a');
		a.href = url;
		a.download = filename;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}
	
	toFormat(data: string, format: string = "Title") {
		switch(format){
			case "Title" : return data.charAt(0).toUpperCase() + data.slice(1).toLowerCase();
			case "Money" : return this.currencyPipe.transform(data, 'MYR ');
			case "Date" : {
				const date = new Date(data);
				return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
			}
			case "TitleSpace" : return data.replace(/([a-z])([A-Z])/g, '$1 $2');
			case "EnumString": return data.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
			default : return data.charAt(0).toUpperCase() + data.slice(1).toLowerCase();
		}	
	}

	formatDate(dateString: string): string {
	  const date = new Date(dateString);
	  const year = date.getFullYear();
	  const month = String(date.getMonth() + 1).padStart(2, '0');
	  const day = String(date.getDate()).padStart(2, '0');
	  return `${year}-${month}-${day}`;
	}
	
	
	isFormatValid(format: string, data: string)
	{
		let isValid = false;
		switch (format) {
			case 'Password': isValid = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(data); break;
			case 'Email': isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data); break;
			default: isValid = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(data); break;
		}
		return isValid;
	}

	taskLoading(taskLoadingNum: number, setNum: null | number = null){
		setNum && (taskLoadingNum = setNum);
		taskLoadingNum--;
		taskLoadingNum <= 0 && this.showLoading(false);
		return taskLoadingNum;
	}
	windowBack(){ window.history.length > 1 ? window.history.back() : window.close(); }
	useWindow(functionName: string, data: any = null){ return data ? (<any>window)[functionName](data) : (<any>window)[functionName](); }
	
	attachmentIcon(url: any){
		if(url == null || !url){
			return "/assets/img/coming-soon.jpg";
		}
		let urlL = url.toLowerCase();
		if(/\.(jpg|jpeg|png|gif|bmp|tiff|tif|svg|webp|heif|heic)$/i.test(urlL)){
			return url;
		}else if(/\.(pdf|xlsx|xls|xlsm)$/i.test(urlL)){
			return "/assets/img/excel.png";
		}else if(/\.(docx|doc|pptx|ppt)$/i.test(urlL)){
			return "/assets/img/ppt.png";
		}else if(/\.(mp4)$/i.test(urlL)){
			return "/assets/img/mp4.png";
		}else if(/\.(zip|rar|7z|tar|gz|tgz|bz2|xz|lzma|cab|iso|dmg|apk|jar|war|zst|zstd)$/i.test(urlL)){
			return "/assets/img/zip.png";
		}else{
			return "/assets/img/coming-soon.jpg";
		}
	}
}
